import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  base: {},
  closeButton: {
    position: 'absolute',
    top: indent,
    right: indent,
    zIndex: 1,
  },
});
